import { LOCALES, KEYS } from '../constants';

const itITTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_ITALIAN_IT]: {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"Ruolo del partner",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"Integratore",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"Fornitore",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"Livello partner",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"Specializzazione partner",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:"Servizio Cisco Powered",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"Nome partner",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"Sede",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"Paese",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"Parola chiave nome partner",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"Parole chiave nome partner",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"Ordinamento",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"Specializzazioni",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"Specializzazioni partner",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"Livello fornitore e servizi Cisco Powered",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"gold provider",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"premier provider",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"select provider",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"Assicurati una guida",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"Richiedi un preventivo",
    [KEYS.L18N_KEY_LABEL_OPEN ]:"Apri",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"Espandi",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"Comprimi",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"Seleziona un paese/una regione",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"Seleziona un ruolo",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"Seleziona specializzazioni",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"Seleziona servizi Cisco Powered",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"Seleziona una o più competenze",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"Seleziona uno o più livelli",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"Paese/regione del partner",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"Livelli integratore",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"Livelli fornitore",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"Specializzazioni integratore",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Servizi Cisco Powered",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"Nomi partner",
    [KEYS.L18N_KEY_LABEL_BACK ]:"Indietro",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"Tutti i risultati",
    [KEYS.L18N_KEY_LABEL_ALL ]:"Tutti",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"Salvati",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"I miei partner",
    [KEYS.L18N_KEY_LABEL_ADD ]:"Aggiungi",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"Rimuovi",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"Aggiungi e confronta ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"Seleziona almeno un altro",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"Confronta i prodotti selezionati ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"Rimuovi dal comparatore",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"Confronta",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"Livello partner",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"Elaborazione in corso",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"risultato",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"risultati",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"Nessun risultato",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"risultato su",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"risultati su",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"Nessun risultato su",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"Indietro",
    [KEYS.L18N_KEY_LABEL_PREV ]:"Indietro",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"Avanti",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"Salva",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"Competenze",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"Panoramica",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"è un Cisco",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"Gli integratori creano soluzioni end-to-end per i nostri clienti. Operano principalmente in una fase di rivendita, ma contribuiscono tramite competenze esclusive per risolvere i problemi aziendali dei clienti",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"I fornitori sono esperti nella fornitura di soluzioni cloud e gestite. I clienti ricercano maggiore flessibilità nell'utilizzo delle soluzioni e il ruolo dei fornitori sul mercato diventa sempre più cruciale.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"Ricerche precedenti",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"Ricerca precedente",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"Ruoli ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"Tecnologia",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"Settori",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"Integratori",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"Fornitori",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"Altro",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"Altri",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"Nessun altro partner salvato",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"Nessun integratore salvato",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"Nessun fornitore salvato",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"filtra per esigenza",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"ricerca per criteri combinati",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"ricerca per sede",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"1 partner operativo in tutto il mondo",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"Ci sono",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"partner operativi in tutto il mondo",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"Nessun partner operativo",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"1 partner operativo in",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"partner operativi in",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"Nessun partner operativo in",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"Modifica sede",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"Filtra per esigenza",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"Cerca",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"per nome, livello e competenza",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"selezionati",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"Nessuna corrispondenza trovata",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"Sali di livello",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"Scendi di livello",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"Porta il nome in alto",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"Porta il nome in basso",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"È necessario effettuare l'accesso.",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"Per svolgere questa azione è necessario effettuare l'accesso",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"Ripristino ricerca non riuscito",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"Accedi",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"Partner salvato correttamente",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"Impossibile salvare il partner",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"Partner rimosso correttamente",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"Impossibile eliminare il partner",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"Digita una parola chiave per effettuare la ricerca in base al nome, al livello o alla competenza",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"Gli sviluppatori sono esperti che realizzano soluzioni software e hardware su misura basate sulla tecnologia Cisco, offrendo soluzioni esclusive in grado di integrare i sistemi e produrre risultati.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"I consulenti sono esperti con un'ampia conoscenza del settore, che guidano le aziende mentre esplorano soluzioni per fronteggiare problematiche aziendali complesse.​",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"Partner diverso",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"Alfabetico",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"Massima competenza",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"Sviluppatore",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"Consulente",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"Filtri",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"Filtra ",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"Competenza del partner",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"Ignora",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"Specializzazione",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"Competenze",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"Nessuna descrizione fornita.",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"Informazioni su",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"Cancella criteri di confronto",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"Confronto tra partner",
    [KEYS.L18N_KEY_LABEL_ROLE]:"Ruolo",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"Focus tecnologico",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"Descrizione",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"Seleziona lingua",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"Esci",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"Partner inclusivo",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Informazioni su Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Contattaci",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Lavori",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Incontra i nostri partner",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Feedback",
    [KEYS.L18N_KEY_LABEL_HELP]: "Aiuto",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Termini e condizioni",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Informativa sulla privacy",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookie",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Marchi",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Trasparenza della catena di fornitura",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Mappa del sito",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Informazioni su Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Contattaci",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Lavori",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Incontra i nostri partner",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Feedback",
    [KEYS.L18N_KEY_LABEL_HELP]: "Aiuto",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Termini e condizioni",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Informativa sulla privacy",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookie",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Marchi",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Trasparenza della catena di fornitura",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Mappa del sito",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "Come acquistare",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "Partner",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "Prodotti e servizi",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "Soluzioni",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "Supporto",
    [KEYS.L18N_KEY_LABEL_LEARN]: "Impara",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "Esplora Cisco",
    [KEYS.L18N_KEY_LABEL_MENU]: "Menu",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "Chiudi",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "Vedi altro",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "Vedi meno",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "Non hai un account?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "registrati"
  }}
);

export default itITTranslations;
